import { z } from "zod/v4-mini";

import { cz } from "@/utils/zodUtils";

import { TandemEventDefinition } from "../TandemTypes";

export type ControlIQUserMode = "normal" | "sleeping" | "exercising";

export type ControlIQUserModeChangePayload = {
  current_user_mode?: number;
  previous_user_mode?: number;
};

export type ControlIQUserModeChangeEvent = {
  currentUserMode?: ControlIQUserMode;
  previousUserMode?: ControlIQUserMode;
};

const controlIQUserModeChangeSchema = z.object({
  current_user_mode: cz.permissive(z.number()),
  previous_user_mode: cz.permissive(z.number()),
});

export const LID_AA_USER_MODE_CHANGE = {
  value: 0xe5,
  name: "Control-IQ User Mode Change",
  format: "bb..............",
  fields: ["current_user_mode", "previous_user_mode"],
  postprocess: rec => ({
    currentUserMode: getUserMode(rec.current_user_mode),
    previousUserMode: getUserMode(rec.previous_user_mode),
  }),
  schema: controlIQUserModeChangeSchema,
} as const satisfies TandemEventDefinition<ControlIQUserModeChangePayload, ControlIQUserModeChangeEvent>;

const getUserMode = (mode?: number): ControlIQUserMode | undefined => {
  switch (mode) {
    case 0:
      return "normal";
    case 1:
      return "sleeping";
    case 2:
      return "exercising";
    default:
      return undefined;
  }
};
